import { useMutation } from '@tanstack/react-query'

import { updatePassword } from '../auth.api'

export type UpdateForgetPasswordPayload = {
  username: string
  forgotPasswordConfirmationCode: string
  forgotPasswordNewPassword: string
}

export const useUpdateForgetPassword = () => {
  return useMutation({
    mutationFn: ({ username, forgotPasswordConfirmationCode, forgotPasswordNewPassword }: UpdateForgetPasswordPayload) =>
      updatePassword(username, forgotPasswordConfirmationCode, forgotPasswordNewPassword),
  })
}
